
import { EAuthMethod, EAuthMode } from '@/helpers/enums'
import { validateEnum } from '@/helpers/index'

export default {
  name: 'AuthButton',
  props: {
    authMode: {
      validator(value) {
        return validateEnum(value, EAuthMode)
      },
      default: EAuthMode.LOGIN
    },
    authMethod: {
      validator(value) {
        return validateEnum(value, EAuthMethod)
      },
      default: EAuthMethod.EMAIL
    },
    text: { type: String, default: '' },
    id: { type: String, default: '' },
    disabled: Boolean,
    isAlert: Boolean,
    isPrimary: Boolean,
    dark: Boolean,
    outlined: Boolean
  },
  computed: {
    isNotSmallScreen() {
      return !this.$vuetify.breakpoint.smAndDown
    },
    isLoginAuthMode() {
      return this.authMode === EAuthMode.LOGIN
    },
    buttonStyles() {
      return this.isPrimary
        ? {
            color: this.isAlert ? 'info' : 'primary'
          }
        : { color: 'grey lighten-3' }
    },
    buttonId() {
      if (this.id) return this.id

      return this.isLoginAuthMode
        ? `loginWith${this.capitalizeWord(this.authMethod)}`
        : `signupWith${this.capitalizeWord(this.authMethod)}`
    },
    buttonVerbiage() {
      if (this.text) return this.text

      return this.isLoginAuthMode
        ? this.$t(`talent.global.button.${this.authMethod}`)
        : this.$t(`talent.global.button.signup.${this.authMethod}`)
    },
    iconColor() {
      return this.isPrimary ? '' : 'grey darken-2'
    },
    googleIcon() {
      return this.isPrimary
        ? { name: '$vuetify.icons.mdiGoogle' }
        : { src: require('@/resources/app/google.svg') }
    },
    auth0Icon() {
      return this.isPrimary
        ? { name: '$vuetify.icons.randstad', size: '28' }
        : { src: require('@/resources/app/randstad.svg'), size: '21' }
    },
    buttonData() {
      switch (this.authMethod) {
        case EAuthMethod.AUTH0:
          return this.getButtonData({
            icon: {
              ...this.auth0Icon
            }
          })

        case EAuthMethod.ONE_TIME_LINK:
          return this.getButtonData({
            icon: {
              name: '$vuetify.icons.mdiLink',
              size: '28',
              color: this.iconColor
            }
          })

        case EAuthMethod.LINKEDIN:
          return this.getButtonData({
            icon: {
              name: '$vuetify.icons.mdiLinkedin',
              size: '28',
              color: this.isPrimary ? '' : 'var(--linkedin-color)'
            }
          })

        case EAuthMethod.GOOGLE:
          return this.getButtonData({
            icon: this.googleIcon
          })

        case EAuthMethod.MOBILE:
          return this.getButtonData({
            icon: {
              name: '$vuetify.icons.mdiCellphoneText',
              color: this.iconColor
            }
          })

        default:
          return this.getButtonData({
            text: this.$t('talent.global.button.email'),
            icon: {
              name: '$vuetify.icons.mdiEmailOutline',
              alt: 'Envelope Outlined Icon',
              size: '28',
              color: this.iconColor
            }
          })
      }
    }
  },
  methods: {
    getButtonData(options = {}) {
      return {
        id: this.buttonId,
        icon: {
          size: options.icon?.size || '24',
          name: options.icon?.name || '',
          src: options.icon?.src || '',
          color: options.icon?.color || '',
          alt: this.$t(`talent.${this.authMode}.button.alt.${this.authMethod}`)
        },
        text: this.buttonVerbiage,
        action: options?.action || ''
      }
    },
    capitalizeWord(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    }
  }
}
